
import {IndustryDivision} from '../industry.domain';

export type PrimaryIndustrySelectionValue = IndustryDivision | null;

export const PrimaryIndustrySelectionValueOptions: IndustryDivision[] = [];
